export default {
  breakpointS: 640,
  breakpointM: 900,
  breakpointL: 1200,
};
